/**
 * CommandCenter.tsx — /app
 *
 * Default workspace. Operator cockpit — current market state at a glance.
 * Surfaces: regime, bias, confidence, gamma posture, trap risk, thesis summary.
 * Wires to existing HedgeFundModePage via view-model bridge.
 */
import React from 'react';
import { useStore }           from '../../store';
import { WatchlistSidebar }   from '../../features/watchlist/WatchlistSidebar';
import { HedgeFundModePage }  from '../../features/hedgefund/HedgeFundModePage';
import { DEFAULT_SMC_OVERLAYS } from '../../types';

export function CommandCenter() {
  const { activeSymbol } = useStore();
  const [hfModule, setHfModule]     = React.useState('home');
  const [smcOverlays, setSmcOverlays] = React.useState(DEFAULT_SMC_OVERLAYS);

  const sym  = activeSymbol ?? '';
  if (!sym) return (
    <div style={{
      display: 'flex', minHeight: 0, flex: '1 1 0%',
      fontFamily: "'Courier New', monospace",
    }}>
      <aside style={{ width: 220, flexShrink: 0, borderRight: '1px solid #1A3050', overflowY: 'auto' }}>
        <WatchlistSidebar />
      </aside>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', color: '#3A5070' }}>
          <div style={{ fontSize: 28, marginBottom: 12, opacity: 0.3 }}>⬡</div>
          <div style={{ fontSize: 11, letterSpacing: 2 }}>SELECT A SYMBOL TO BEGIN</div>
        </div>
      </div>
    </div>
  );

  // Delegate to the existing HF workspace (the proven operator UI)
  return (
    <div style={{ display: 'flex', minHeight: 0, flex: '1 1 0%' }}>
      <aside style={{ width: 200, flexShrink: 0, borderRight: '1px solid #1A3050', overflowY: 'auto' }}>
        <WatchlistSidebar />
      </aside>
      <div style={{ flex: 1, overflowY: 'auto', minWidth: 0 }}>
        <HedgeFundModePage
          symbol={sym}
          hfModule={hfModule}
          setHfModule={setHfModule}
          smcOverlays={smcOverlays}
          onSmcOverlaysChange={setSmcOverlays}
        />
      </div>
    </div>
  );
}
